/**
 * Curated list of schema.org LocalBusiness subtypes usable as a trade
 * (category) `schemaType`. Ordered by relevance to building/craft trades,
 * with a few extra types kept because they are already used by some trades.
 */
export const tradeSchemaTypeOptions = [
  {
    key: 'GeneralContractor',
    value: 'GeneralContractor',
    text: 'GeneralContractor (entreprise générale du bâtiment)',
  },
  {
    key: 'RoofingContractor',
    value: 'RoofingContractor',
    text: 'RoofingContractor (couverture / toiture)',
  },
  {
    key: 'HVACBusiness',
    value: 'HVACBusiness',
    text: 'HVACBusiness (chauffage / climatisation / ventilation)',
  },
  { key: 'Plumber', value: 'Plumber', text: 'Plumber (plomberie)' },
  {
    key: 'Electrician',
    value: 'Electrician',
    text: 'Electrician (électricité)',
  },
  {
    key: 'HousePainter',
    value: 'HousePainter',
    text: 'HousePainter (peinture)',
  },
  { key: 'Locksmith', value: 'Locksmith', text: 'Locksmith (serrurerie)' },
  {
    key: 'HomeAndConstructionBusiness',
    value: 'HomeAndConstructionBusiness',
    text: 'HomeAndConstructionBusiness (maison / construction / services)',
  },
  { key: 'Architect', value: 'Architect', text: 'Architect (architecture)' },
  {
    key: 'ProfessionalService',
    value: 'ProfessionalService',
    text: 'ProfessionalService (service professionnel / études)',
  },
  {
    key: 'LocalBusiness',
    value: 'LocalBusiness',
    text: 'LocalBusiness (commerce local générique)',
  },
  {
    key: 'AutoRepair',
    value: 'AutoRepair',
    text: 'AutoRepair (réparation automobile)',
  },
  {
    key: 'AutomotiveBusiness',
    value: 'AutomotiveBusiness',
    text: 'AutomotiveBusiness (automobile)',
  },
  {
    key: 'RealEstateAgent',
    value: 'RealEstateAgent',
    text: 'RealEstateAgent (immobilier)',
  },
  {
    key: 'InsuranceAgency',
    value: 'InsuranceAgency',
    text: 'InsuranceAgency (assurance)',
  },
  {
    key: 'FinancialService',
    value: 'FinancialService',
    text: 'FinancialService (service financier)',
  },
  {
    key: 'AccountingService',
    value: 'AccountingService',
    text: 'AccountingService (comptabilité)',
  },
  { key: 'Attorney', value: 'Attorney', text: 'Attorney (avocat)' },
  {
    key: 'MovingCompany',
    value: 'MovingCompany',
    text: 'MovingCompany (déménagement)',
  },
  {
    key: 'FoodEstablishment',
    value: 'FoodEstablishment',
    text: 'FoodEstablishment (restauration / traiteur)',
  },
  {
    key: 'PhotographicStudio',
    value: 'PhotographicStudio',
    text: 'PhotographicStudio (photographie)',
  },
] as const;

export const tradeSchemaTypeValues = tradeSchemaTypeOptions.map(
  (option) => option.value,
);
